export const ExperimentAPINames: Record<string, string> = {
  ArticleRecirculationWidgets: "Article 2.0 Recirculation Widgets",
};
